import React from "react";
import classes from "./SmallSpinner.module.css";
const SmallSpinner = () => {
  return <div className={classes.container}></div>;
};

export default SmallSpinner;
